<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Event Date & Time Label"
    >
      <b-input-group>
        <flat-pickr
          v-model="startDateValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <hr class="dividerHR filter-divider">
    <b-form-group label="Waiting List">
      <b-form-radio-group
        v-model="waitingListValue"
        :options="radioOptions"
        name="waitingList-radios-stacked"
        stacked
      />
    </b-form-group>
    <hr class="dividerHR filter-divider">
    <b-form-group
      label="Time Slot Booking"
      @click.native.stop
    >
      <v-select
        v-model="timeSlotBookingValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="text"
        placeholder="Select from list"
        multiple
        :options="timeSlotBookingOptions"
        :clearable="false"
        :reduce="text => text.value"
      />
    </b-form-group>

    <div v-if="$route.params.type == 'all-event'">
      <hr class="dividerHR filter-divider">
      <b-form-group label="Status">
        <b-form-checkbox
          v-for="option in statusOptions"
          :key="option.value"
          v-model="statusFilterValue"
          :value="option.value"
          name="flavour-3a"
        >
          {{ option.label }}
        </b-form-checkbox>
      </b-form-group>
    </div>
    <b-button
      variant="outline-primary"
      size="sm"
      class="mr-1"
      @click="clearFilter"
    >
      Clear All
    </b-button>
    <b-button
      variant="primary"
      size="sm"
      @click="applyFilter"
    >
      Apply Filter
    </b-button>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BInputGroup, BInputGroupAppend, BFormCheckbox, BFormRadioGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BInputGroup,
    BFormRadioGroup,
    BInputGroupAppend,
    BFormCheckbox,
    vSelect,
    flatPickr,
  },
  props: {
    statusFilter: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    startDate: {
      type: [String, null],
      default: null,
    },
    waitingList: {
      type: [String, null],
      default: null,
    },
    timeSlotBooking: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    timeSlotBookingOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      startDateValue: this.startDate,
      waitingListValue: this.waitingList,
      statusFilterValue: JSON.parse(JSON.stringify(this.statusFilter)) || [],
      timeSlotBookingValue: JSON.parse(JSON.stringify(this.timeSlotBooking)) || [],
      callNatures: [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
      radioOptions: [
        { text: 'Yes', value: 'yes' },
        { text: 'No', value: 'no' },
      ],
    }
  },
  watch: {
    startDate: {
      immediate: true,
      handler(val) {
        this.startDateValue = val
      },
    },
    waitingList: {
      immediate: true,
      handler(val) {
        this.waitingListValue = val
      },
    },
    statusFilter: {
      immediate: true,
      handler(val) {
        this.statusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    timeSlotBooking: {
      immediate: true,
      handler(val) {
        this.timeSlotBookingValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    showAgainDropdown() {
      if (this.startDateValue) {
        this.$emit('emitShowFilter')
      }
    },
    applyFilter() {
      this.$emit('update:startDate', this.startDateValue)
      this.$emit('update:waitingList', this.waitingListValue)
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:timeSlotBooking', this.timeSlotBookingValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.startDateValue = ''
      this.waitingListValue = ''
      this.statusFilterValue = []
      this.timeSlotBookingValue = []
      this.$emit('update:startDate', this.startDateValue)
      this.$emit('update:waitingList', this.waitingListValue)
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:timeSlotBooking', this.timeSlotBookingValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
